module.exports = __webpack_public_path__ + "img/login-l-red.0a7c9293.png";